import { ScreeningItem, ScreeningPscResponse } from "../types/Screening";
import { getCurrentSessionIdToken } from "../queries/authToken";
import axios from "axios";

export const getScreeningData = async (imos: (string | number)[]) => {
    try {
        const url = `${
            process.env.REACT_APP_IDWAL_API_URL
        }/Screening?imos=${imos.join(",")}`;
        const token = await getCurrentSessionIdToken();

        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token
        };

        const response = await axios.get<ScreeningItem[]>(url, {
            headers
        });

        return response.data;
    } catch (e) {
        console.error(e);
    }

    return [];
};

export const getMainShipImage = async (imo: string) => {
    try {
        const url = `${
            process.env.REACT_APP_IDWAL_API_URL
        }/Fleet/mainShipImage/${imo}`;
        const token = await getCurrentSessionIdToken();

        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token
        };

        const response = await axios.get(url, {
            headers
        });

        return response.data;
    } catch (e) {
        console.error(e);
    }

    return [];
};

export const getScreeningPscData = async (imo: string, token: string | undefined) => {
    if (token) {
        try {
            const url = `${
                process.env.REACT_APP_PSC_API_URL
            }lli?imo=${imo}`;

            const headers = {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            };

            const response = await axios.get<ScreeningPscResponse>(url, {
                headers
            });

            return response.data;
        } catch (e) {
            console.error(e);
        }
    }

    return undefined;
};
